import { defineComponent, ref, computed, watch, onMounted, onUnmounted, install } from "vue-demi";
import { EditorState } from "@codemirror/state";
import { EditorView } from "@codemirror/view";
import { merge, compact } from "lodash";
var __vue2_script = defineComponent({
  name: "CodeMirror",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    theme: {
      type: Object,
      default: void 0
    },
    dark: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    },
    extensions: {
      type: Array,
      default: void 0
    },
    phrases: {
      type: Object,
      default: void 0
    },
    lang: {
      type: Object,
      default: void 0
    },
    linter: {
      type: Array,
      default: void 0
    }
  },
  emits: ["update:modelValue", "update"],
  setup(props, context) {
    const editor = ref();
    const modelValue = ref(props.modelValue);
    const dark = ref(props.dark);
    const emit = context.emit;
    const extensions = computed(() => {
      const ext = [
        EditorView.updateListener.of((update) => {
          emit("update", update);
        }),
        EditorView.theme(props.theme || {}, { dark: dark.value }),
        props.phrases ? EditorState.phrases.of(props.phrases) : void 0,
        props.lang,
        props.readonly ? EditorState.readOnly.of(props.readonly) : void 0,
        props.editable ? EditorView.editable.of(props.editable) : void 0
      ];
      if (props.linter) {
        merge(ext, props.linter);
      }
      if (props.extensions) {
        merge(ext, props.extensions);
      }
      return compact(ext);
    });
    let view;
    watch(modelValue, (current) => {
      if (view.composing) {
        return;
      }
      const previous = view.state.selection;
      view.setState(EditorState.create({
        doc: current,
        extensions: extensions.value,
        selection: previous
      }));
    });
    watch(dark, () => {
      view.setState(EditorState.create({
        doc: modelValue.value,
        extensions: extensions.value
      }));
    });
    onMounted(() => {
      const value = !modelValue.value && editor.value ? editor.value.childNodes[0].innerText : modelValue.value;
      view = new EditorView({
        state: EditorState.create({
          doc: value,
          extensions: extensions.value
        }),
        parent: editor.value,
        dispatch: (tr) => {
          view.update([tr]);
          if (tr.changes.empty)
            return;
          modelValue.value = view.state.doc.toString();
          emit("update:modelValue", modelValue.value);
        }
      });
    });
    onUnmounted(() => view.destroy());
    return {
      context,
      editor
    };
  }
});
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    ref: "editor",
    staticClass: "vue-codemirror"
  }, [_c("aside", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.context.slots.default,
      expression: "!context.slots.default"
    }]
  }, [_vm._t("default")], 2)]);
};
var staticRenderFns = [];
function normalizeComponent(scriptExports, render2, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render2) {
    options.render = render2;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var CodeMirror = /* @__PURE__ */ function() {
  return __component__.exports;
}();
/**
 * Vue CodeMirror6 Component
 *
 * @license MIT
 * @author Logue {@link logue@hotmail.co.jp}
 * @copyright 2022 Masashi Yoshikawa {@link https://logue.dev/} All rights reserved.
 * @see {@link https://github.com/logue/vue-codemirror6}
 */
install();
const installCodeMirror = (app) => {
  app.component("CodeMirror", CodeMirror);
};
export { CodeMirror, CodeMirror as default, installCodeMirror as install };
